import React from "react";
import { resolveMediaUrl } from "./utils";

const TypingIndicator = ({ typingUsers = [], messages = [], currentUserId }) => {
  let firstTypingUser = typingUsers[0] || null;
  
  // If user info is incomplete or missing, try to find from recent messages
  // The typing user is usually the same as the last received message sender
  if (!firstTypingUser || !firstTypingUser.profileimg || !firstTypingUser.firstname) {
    // Find the last received message (not from current user)
    for (let i = messages.length - 1; i >= 0; i--) {
      const msg = messages[i];
      if (msg?.sender && 
          String(msg.sender._id) !== String(currentUserId) && 
          msg.sender._id !== "me" &&
          (msg.sender.profileimg || msg.sender.firstname)) {
        // Use this as the typing user
        firstTypingUser = {
          _id: msg.sender._id,
          firstname: msg.sender.firstname || firstTypingUser?.firstname || "User",
          lastname: msg.sender.lastname || firstTypingUser?.lastname || "",
          profileimg: msg.sender.profileimg || firstTypingUser?.profileimg || null,
        };
        break;
      }
    }
  } else if (firstTypingUser && (!firstTypingUser.profileimg || !firstTypingUser.firstname)) {
    // If we have user but incomplete info, try to find from messages
    for (let i = messages.length - 1; i >= 0; i--) {
      const msg = messages[i];
      if (msg?.sender && String(msg.sender._id) === String(firstTypingUser._id)) {
        firstTypingUser = {
          ...firstTypingUser,
          firstname: msg.sender.firstname || firstTypingUser.firstname || "User",
          lastname: msg.sender.lastname || firstTypingUser.lastname || "",
          profileimg: msg.sender.profileimg || firstTypingUser.profileimg || null,
        };
        break;
      }
    }
  }
  
  const displayName = firstTypingUser?.firstname || firstTypingUser?.lastname || "User";
  const profileImage = firstTypingUser?.profileimg;

  return (
    <div className="d-flex mb-2 align-items-end justify-content-start" style={{ paddingRight: "15%" }}>
      {profileImage ? (
        <img
          src={resolveMediaUrl(profileImage)}
          alt={displayName}
          className="rounded-circle me-2"
          style={{ width: 32, height: 32, objectFit: "cover", flexShrink: 0 }}
          onError={(e) => {
            e.target.style.display = "none";
            const fallback = e.target.nextElementSibling;
            if (fallback) fallback.style.display = "flex";
          }}
        />
      ) : null}
      {/* <div
        className="avatar-xs rounded-circle bg-primary-subtle text-primary fw-bold d-flex align-items-center justify-content-center me-2"
        style={{ 
          width: 32, 
          height: 32, 
          flexShrink: 0,
          display: profileImage ? "none" : "flex"
        }}
      >
        {(displayName && displayName !== "User") ? displayName.charAt(0).toUpperCase() : (firstTypingUser?._id ? "U" : "T")}
      </div> */}
      <div
        className="bg-white text-dark border p-3 rounded-3"
        style={{
          borderRadius: "18px 18px 18px 4px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.1)"
        }}
      >
        <span className="text-muted fst-italic">typing...</span>
      </div>
    </div>
  );
};

export default TypingIndicator;

